/**
 * De tekengrootte waarbij een naam binnen z'n vakje past.
 *
 * Per object berekend, niet per diagram: het minimum over alle objecten
 * delen trok de tekst van een heel diagram omlaag zodra er één smal vakje
 * met een lange naam bij stond (2026-09-01). Een expliciete keuze van de
 * modelleur wint hier altijd van.
 *
 * Staat apart omdat twee canvassen 'm gebruiken — het gewone React-Flow-
 * canvas en het banen-canvas, waar de kaartbreedte vastligt en een naam dus
 * al snel niet past.
 */
export const DIAGRAM_BASE_FONT = 13;
export const DIAGRAM_MIN_FONT = 9;

export function passendeFont(
  label: string,
  breedte: number | undefined,
  /** Hoeveel regels de tekst mag gebruiken. Meer regels = minder krimp. */
  regels = 2,
): number {
  if (!label || label.length === 0) return DIAGRAM_BASE_FONT;
  const beschikbaar = Math.max(40, (breedte ?? 140) - 24);
  // De ruimte is de breedte maal het aantal regels dat eronder past: eerst
  // terugloop, en pas kleiner worden als ook dat niet volstaat.
  const perTeken = (beschikbaar * Math.max(1, regels)) / label.length;
  // Heuristiek: tekenbreedte is ongeveer 0,55 x de tekengrootte bij SemiBold.
  const nodig = Math.floor(perTeken / 0.55);
  return Math.min(DIAGRAM_BASE_FONT, Math.max(DIAGRAM_MIN_FONT, nodig));
}
